import { Box, Typography, Paper } from "@mui/material";
import Lottie from 'react-lottie';
import checkCompleted from "../../../../../../assets/animations/check-completed-green.json";
import { colors, alphaVar } from "../../../../../ui/colors";

export function JobCompleted() {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: checkCompleted,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: { xs: 2, md: 3 },
        bgcolor: "var(--fx-surface-sunken, #F8FAFC)",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          px: { xs: 3, md: 4 },
          py: { xs: 3, md: 3.5 },
          borderRadius: "16px",
          bgcolor: "background.paper",
          border: `1px solid ${alphaVar(colors.gray[100], 0.55)}`,
          boxShadow: "none",
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1.25,
          maxWidth: 900,
          width: '100%',
        }}
      >
        <Box sx={{ width: 96, height: 96 }}>
          <Lottie options={defaultOptions} height={96} width={96} />
        </Box>

        <Typography fontWeight={600} color="text.primary" textAlign="center" sx={{ fontSize: { xs: "1.15rem", sm: "1.3rem" } }}>
          Job Completed
        </Typography>

        <Typography color="text.secondary" textAlign="center" sx={{ fontSize: { xs: "0.75rem", sm: "0.82rem" }, maxWidth: 460 }}>
          Congratulations! Your job has been successfully completed. Thank you for using our service.
        </Typography>
      </Paper>
    </Box>
  );
}
